import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    posts: [],
    modelDefault: {
        id: null,
        bot_id: null,
        post_id: null,
        group_id: null,
        channel_id: null,
        platform: 'vk',
        event_id: null,
        post_time: null,
        like_control_time: 0,
        created_at: null,
        status: 1,
        pending: 1,
        title: '',
        text: '',
        attachment: null,
        other_params: {
            variableId: 0,
            messageId: 0,
            value: 1,
            setValue: 2,
            postIdToVariable: null,
            changeGlobalVariables: {
                variablesIds: [],
                function: ''
            }
        }
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
